import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "thead[appSaqTableHeader]",
    templateUrl: "./table_header.component.html",
    styleUrls: ["./table_header.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHeaderComponent {}
